import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

// Shown while the login page itself is being loaded (and for any signed-out page): the shape of the login card - logo, title,
// two fields, button - centred on the page colour, so the screen goes from the first "Loading Scholae..." to the login form
// without a different-looking placeholder in between. The dashboard skeleton (AppBackdrop) belongs inside the dashboard layout
// and has no place here.
export default function AuthLoading() {
  return (
    <div
      aria-busy="true"
      aria-label="Loading"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#eef2f6',
        padding: 16,
        boxSizing: 'border-box',
      }}>
      <div
        style={{
          width: '100%',
          maxWidth: 478,
          background: '#ffffff',
          borderRadius: 4,
          padding: '28px 16px 24px',
          boxSizing: 'border-box',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Skeleton variant="circle" width={72} height={72} animation="wave" />
        <Skeleton variant="text" width="34%" height={30} animation="wave" style={{ marginTop: 18 }} />
        <Skeleton
          variant="rect"
          width="100%"
          height={56}
          animation="wave"
          style={{ borderRadius: 10, marginTop: 24 }}
        />
        <Skeleton
          variant="rect"
          width="100%"
          height={56}
          animation="wave"
          style={{ borderRadius: 10, marginTop: 15 }}
        />
        <Skeleton variant="rect" width="100%" height={42} animation="wave" style={{ borderRadius: 6, marginTop: 24 }} />
        <Skeleton variant="text" width="60%" height={20} animation="wave" style={{ marginTop: 22 }} />
      </div>
    </div>
  );
}
